<template>
	<div id="body">
		<div class="title">
			<i class="bi bi-receipt"></i> 实名认证
		</div>

		<div class="smrz">
			<div style="margin-top: 20px;">
				<el-form id="form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
					style="width: 93%;">
					<el-form-item label="真实姓名" prop="realName">
						<el-input v-model.trim="ruleForm.realName" placeholder="请输入真实姓名"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" prop="idNumber">
						<el-input v-model.trim="ruleForm.idNumber" placeholder="请输入身份证号"></el-input>
					</el-form-item>
					<el-form-item label="证件人像面" prop="idPositive">
						<el-upload class="avatar-uploader" :headers="headers" :action="this.$store.state.upload" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
							v-loading="loading">

							<img v-if="ruleForm.idPositive" :src="ruleForm.idPositive" v-model="ruleForm.idPositive"
								class="avatar">

							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="证件国徽面" prop="idOpposite">
						<el-upload class="avatar-uploader" :headers="headers" :action="this.$store.state.upload" :show-file-list="false"
							:on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1" v-loading="loading1"
							>

							<img v-if="ruleForm.idOpposite" :src="ruleForm.idOpposite" v-model="ruleForm.idOpposite"
								class="avatar">

							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item style="margin-left: -80px;">
						<button type="button" class="btn btn-outline-primary" @click="submit('ruleForm')">提交</button>
					</el-form-item>
				</el-form>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				loading1: false,
				headers:{"openId":localStorage.getItem('openId'),"thirdsession":this.$Cookies.get('thirdsession')},
				ruleForm: {
					realName: '',
					idNumber: '',
					idPositive: '',
					idOpposite: '',
					openId: ''
				},
				rules: {
					realName: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					idNumber: [{
							required: true,
							message: '请输入身份证号码',
							trigger: 'blur'
						},
						{
							min: 18,
							max: 18,
							message: '请检查身份证号码是否有误',
							trigger: 'blur'
						}
					],
					idPositive: [{
						required: true,
						message: "请上传身份证人像面",
						trigger: "blur",
					}],
					idOpposite: [{
						required: true,
						message: "请上传身份证国徽面",
						trigger: "blur",
					}],
				}
			};
		},
		methods: {
			submit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api({
							method: 'post',
							url: '/mobileLogin/uploadIdInfo',
							data: this.ruleForm
						}).then((res) => {
							if (res.data.code == 200) {
								this.$router.push('/success?text=信息提交成功，请耐心等待认证通过')
							} else {
								alert("服务器错误,请联系管理员处理")
							}
						})
					} else {
						return false;
					}
				});
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.idPositive = this.$store.state.showUpload + res.url
				this.loading = false
			},
			beforeAvatarUpload(file) {
				const isLt30M = file.size / 1024 / 1024 < 30;

				if (!isLt30M) {
					this.$message.error('上传图片大小不能超过 30MB!');
					this.loading = false
				} else {
					this.loading = true
					return isLt30M;
				}
			},
			handleAvatarSuccess1(res, file) {
				this.ruleForm.idOpposite = this.$store.state.showUpload + res.url
				this.loading1 = false
			},
			beforeAvatarUpload1(file) {
				const isLt30M = file.size / 1024 / 1024 < 30;

				if (!isLt30M) {
					this.$message.error('上传图片大小不能超过 30MB!');
					this.loading1 = false
				} else {
					this.loading1 = true
					return isLt30M;
				}
			},
		},
		created() {
			this.ruleForm.openId = localStorage.getItem('openId');
		},
	}
</script>

<style>
	.smrz {
    height: 100%;
    overflow-y: auto;
		width: 95%;
		margin: 0 auto;
		line-height: 3.025rem;
		background-color: #FFFFFF;
		padding-top: 10%;
		padding-bottom: 10%;
		bottom: 20%;
		border-radius: 1%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		width: 100%;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 15px;
		color: #8c939d;
		width: 178px;
		text-align: center;
	}

	.avatar {
		width: 100%;
		display: block;
	}


	.img {
		width: 100%;
	}

	.btn {
		margin: 0 auto;
		width: 18rem;
		display: block;
		margin-top: 1.9375rem;
	}
</style>
